export const useStorePathways = defineStore('StorePathways', {
    state: () => ({
        pathways: null,
        error: null,
        filter: {
            paginate: {
                auto: false,
            },
            fields: {
                pathway_hidden: 0,
            },
            order: [
                {field: 'pathway_order', asc: true},
                {field: 'pathway_name', asc: true},
                {field: 'id_pathway', asc: true},
            ],
        },
    }),
    actions: {
        async getPathways () {
            this.error = null;
            ({pathways: this.pathways, error: this.error} = await useQueryPathways().get(this.filter));
        },
    },
});
